export default __webpack_public_path__ + "static/media/bkg--agent.ee2f40a1.jpg";